import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserEmergencyContactForm } from "Bands/components";
import { editUserEmergencyContact, userEmergencyContactSelectorCreator } from "Bands/state";
import { IUserEmergencyContactPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Contact } from "shared/assets/icons";

const { userEmergencyContact: contactCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserEmergencyContactModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const contactIdSelector = useMemo(() => userEmergencyContactSelectorCreator(id), [id]);
  const contact = useSelector(contactIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserEmergencyContactPatchData) => {
    dispatch(editUserEmergencyContact({ id, data }));
  };

  return (
    <UserEntityModal
      defaultValues={contact}
      title={contactCopy.edit.title}
      icon={Contact}
      action={USER_ACTIONS.editUserEmergencyContact}
      buttons={buttons}
      successMessage={contactCopy.messages.edited}
      Component={UserEmergencyContactForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
